import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import React, { useState } from 'react';

const SelectMui = ({ values, label, state, onChange, width, helperText, error, disabled, size }) => {
  return (
    <FormControl sx={{ minWidth: 200, width: width }} size={size} error={error}>
      <InputLabel>{label}</InputLabel>
      <Select
        sx={{ fontSize: '1rem' }}
        disabled={disabled}
        label={label}
        value={state}
        onChange={onChange}
      >
        {values.map((e, index) => {
          return <MenuItem key={index} value={e.value}>{e.label}</MenuItem>
        })}
      </Select>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
};

export default SelectMui